import React, { useState } from 'react';
import ConfirmationModal from '@grnhse/seedling/lib/birch/components/modals/confirmation_modal';
import { Body } from '@grnhse/seedling/lib/birch/typography';
import {
  PrimaryButton,
  SecondaryButton,
} from '@grnhse/seedling/lib/birch/components/buttons';
import { withLocalePrefix } from 'shared/utils/translation';
import { SelectionsHelper } from 'talent_matching/hooks/use_selections_helper';
import { standardRequestWithErrorFlash } from 'shared/utils/request';
import { useUserContext } from 'talent_matching/contexts/user_context';

const t = withLocalePrefix('talent_matching.bulk_actions.fraud_report');

type Props = {
  isOpen: boolean;
  closeModal: () => void;
  selectionsHelper: SelectionsHelper;
};

const FraudReportModal = ({ isOpen, closeModal, selectionsHelper }: Props) => {
  const [submitting, setSubmitting] = useState(false);
  const { paths, appReviewSessionId } = useUserContext();

  const onSubmit = async () => {
    const payload = {
      application_ids: selectionsHelper.applicationIds,
      app_review_session_id: appReviewSessionId,
      source: 'talent_matching',
    };

    setSubmitting(true);

    try {
      await standardRequestWithErrorFlash.post(
        paths.bulkRequestFraudReportsPath,
        payload,
        {
          successMessage: t('success', {
            count: selectionsHelper.totalSelected,
          }),
        }
      );
      closeModal();
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <ConfirmationModal
      isOpen={isOpen}
      onDismiss={closeModal}
      ariaLabel={t('title', { count: selectionsHelper.totalSelected })}
    >
      <ConfirmationModal.Header>
        {t('title', { count: selectionsHelper.totalSelected })}
      </ConfirmationModal.Header>
      <ConfirmationModal.Body>
        <Body>{t('body')}</Body>
      </ConfirmationModal.Body>
      <ConfirmationModal.Footer>
        <SecondaryButton onClick={closeModal} disabled={submitting}>
          {t('cancel')}
        </SecondaryButton>
        <PrimaryButton onClick={onSubmit} disabled={submitting}>
          {t('confirm')}
        </PrimaryButton>
      </ConfirmationModal.Footer>
    </ConfirmationModal>
  );
};

export default FraudReportModal;
